import React from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Layout from './src/components/Layout';
import './src/styles/global.css';

const cache = createCache({ key: 'css', prepend: true });
cache.compat = true;

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={cache}>{element}</CacheProvider>
);

export const wrapPageElement = ({ element }) => <Layout>{element}</Layout>;

export const onInitialClientRender = () => {
  const hideLoader = () => {
    const loader = document.getElementById('___page-loader');
    if (!loader) return;
    loader.style.opacity = '0';
    setTimeout(() => loader.remove(), 400);
  };

  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader, { once: true });
  }
};
